import React from 'react'
import {Col, Row, Table} from "antd";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import gokhanLogo from '../../../logo/gokhanLogo.jpeg'
import armaledLogo from '../../../logo/armaled_logo.jpeg'
import config from "../../../config";

const logoStyle = {
    width: '100%'
}
const columns = [
    {
        title: 'Stok Adı',
        dataIndex: 'stock',
        key: 'stock'
    },
    {
        title: 'Miktar',
        dataIndex: 'quantity',
        key: 'quantity'
    },
    {
        title: 'Birim',
        dataIndex: 'unit',
        key: 'unit'
    },
    {
        title: 'Sevk Tarihi',
        dataIndex: 'shippingDate',
        key: 'shippingDate',
        render: t => userDateFormatter(t)
    }
]

class PurchasePrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableDataSource: [],
            abstractColumns: [
                {title: 'Satın Alma No', dataIndex: 'purchaseNumber'},
                {title: 'Teslimat', dataIndex: 'delivery'},
                {title: 'Kur Bilgisi', dataIndex: 'exchangeRate'},
                {title: 'Ödeme', dataIndex: 'payment'},
            ],
            abstractTableData: [],
            armaText: 'ARMA LED AYDINLATMA ELEMANLARI İMALAT SAN.VE TİC.A.Ş',
            gokhanText: 'GÖKHAN ELEKTRİK MALZEMELERİ SAN. VE TİC.LTD.ŞTİ',
            address: 'Şerifali mah.Beyit Sk. BSB Plaza No:52 Kat:3 34775 Ümraniye-İstanbul'
        }
    }

    componentDidMount() {
        const purchase = this.props.purchase
        const purchaseContent = purchase.contentOfPurchaseList.map((item, index) => {
            return {
                key: index,
                stock: `${item.stock.code} - ${item.stock.name}`,
                quantity: item.quantity,
                unit: item.unit,
                shippingDate: item.shippingDate
            }
        })
        this.setState({
            abstractTableData: [{
                key: 0,
                delivery: this.props.purchase.delivery,
                exchangeRate: this.props.purchase.exchangeRate,
                payment: this.props.purchase.payment,
                purchaseNumber: this.props.purchase.purchaseNumber
            }]
        })
        this.setState({tableDataSource: purchaseContent})
    }


    render() {
        return (
            <React.Fragment>
                <div style={{padding: '26px'}}>
                    <Row justify={'start'}>
                        <Col span={5}>
                            <img src={config.currentTenant() === 'gokhan' ? gokhanLogo : armaledLogo} alt=""
                                 style={logoStyle}/>
                        </Col>
                    </Row>
                    <Row justify={'start'}>
                        <Col span={7}>
                            <p className={'font-bold'}>
                                {
                                    config.currentTenant().toLowerCase() === 'arma'
                                        ? this.state.armaText
                                        : this.state.gokhanText
                                }
                            </p>
                            <p className={'font-light'}>{this.state.address}</p>
                        </Col>
                    </Row>
                    <div style={{margin: '32px 0'}}>
                        <Row>
                            <Col span={24}>
                                <Table columns={this.state.abstractColumns} dataSource={this.state.abstractTableData}
                                       pagination={false}/>
                            </Col>
                        </Row>
                    </div>
                    <Row justify={'center'}>
                        <Col span={7}>
                            <h4>Tedarikçi Teklif Formu</h4>
                        </Col>
                    </Row>
                    <Table columns={columns} dataSource={this.state.tableDataSource} pagination={false}/>
                </div>
            </React.Fragment>
        )
    }
}

export default PurchasePrint